// 並べ替え。ドラッグと、「前へ／後へ」のボタン（キーボード・読み上げの操作に必須）の両方で使う。
// サーバーへ送る ids は、表示中のカードすべてを並べた配列でなければならない。

// from の位置の要素を to の位置へ動かした、新しい配列。範囲外は変更しない。
export function arrayMove<T>(items: readonly T[], from: number, to: number): T[] {
  const result = [...items];
  if (from < 0 || from >= result.length || to < 0 || to >= result.length || from === to) return result;
  const [moved] = result.splice(from, 1);
  result.splice(to, 0, moved);
  return result;
}

// 「前へ」（delta = -1）「後へ」（delta = 1）。先頭・末尾では動かない。
export function moveBy(ids: readonly number[], id: number, delta: -1 | 1): number[] {
  const from = ids.indexOf(id);
  if (from < 0) return [...ids];
  return arrayMove(ids, from, from + delta);
}

export const canMoveBy = (ids: readonly number[], id: number, delta: -1 | 1): boolean => {
  const from = ids.indexOf(id);
  return from >= 0 && from + delta >= 0 && from + delta < ids.length;
};

// ドラッグの結果（移動元の id を、移動先の id の位置へ）。
export function moveToPositionOf(ids: readonly number[], activeId: number, overId: number): number[] {
  const from = ids.indexOf(activeId);
  const to = ids.indexOf(overId);
  if (from < 0 || to < 0) return [...ids];
  return arrayMove(ids, from, to);
}

export const sameOrder = (a: readonly number[], b: readonly number[]): boolean =>
  a.length === b.length && a.every((id, index) => id === b[index]);

// 表示中のカード（並び順）を、一覧の応答から取り出す。
export function visibleIds(cards: ReadonlyArray<{ id: number; status: string }>): number[] {
  return cards.filter(card => card.status === "visible").map(card => card.id);
}

// 今日の一枚はグリッドの先頭に別枠で出し、残りを並び順で続ける。
export function withoutPinned<T extends { id: number }>(cards: readonly T[], pinnedId: number | null): T[] {
  return pinnedId === null ? [...cards] : cards.filter(card => card.id !== pinnedId);
}
